export default "__VITE_ASSET__Cnk2EMnh__"